<template>
<section>
  <!-- shows when loading -->
  <LoadingProductsList v-if="isLoading" />
  <!-- shows when loaded -->
  <section v-else-if="Array.isArray(productsList) && productsList.length > 0">
    <!-- Products List -->
      <SectionTitle v-if="title" class="px-2 sm:px-0 py-0" :title="title"/>
      <!-- <TransitionGroup name="products-list" tag="ul" id="" class="flex flex-wrap gap-y-6 gap-x-2 ">
        <li v-for="product in productsList" :key="product.id" :class="`${ product.ad_type === 'store' ||  product.ad_type === 'store_product' ? 'w-full' : ' w-full sm:w-[48%] xl:w-[32%] 2xl:w-[24%]'}`"> -->


                          <!-- Store Ad item -->
                          <!-- <StoreAdItem v-if="product.ad && product.ad_type == 'store'" :item="product" /> -->
                <!-- Store & product Ad item -->
                <!-- <StoreProductAdItem v-else-if=" product.ad && product.ad_type == 'store_product'" :item="product" /> -->
                <!-- Regular product item -->
          <!-- <ProductItem v-else :withAds="false" :item="product" :disableVisitingStore="isStorePage" :favoriteProductsIDs="favoriteProductsIDs" :cardDesignId="cardDesignId" /> -->
          <!-- <ProductItem :withAds="true" :item="product" :disableVisitingStore="isStorePage" :favoriteProductsIDs="favoriteProductsIDs" :cardDesignId="cardDesignId" /> -->

        <!-- </li>
      </TransitionGroup> -->

      <TransitionGroup v-if="fromFilterProducts" name="products-list" tag="ul" id="productsItemsList"
          :class="`${isUpdatingProducts ? 'disabled' : ''} products-items-list`">
              <li  v-for="item in productsList"  :key="item.id" 
                   :class="`${(item.ad && item.ad_type !== 'product') ? 'col-span-full' : ''}`"
                   :data-product-id="item.id"
                   @click="saveProductCardPosition(item.id)">
                <!-- Store Ad item -->
                <StoreAdItem v-if="item.ad && item.ad_type === 'store'" :item="item" />
                <!-- Store & product Ad item -->
                <StoreProductAdItem 
                  v-else-if=" item.ad && item.ad_type === 'store_product'" 
                  :item="item"
                  :saveProductCardPosition="saveProductCardPosition"
                  :shouldSavePosition="fromFilterProducts"
                />
                <!-- Regular product item -->
              <ProductItem
                v-else
                :item="item"
                :favoriteProductsIDs="favoriteProductsIDs"
                :withAds="true"
                :portalPage="portalPage"
                :encodedFilterQuery="encodedFilterQuery"
                :searchTerm="searchTerm"
                :saveProductCardPosition="saveProductCardPosition"
                :shouldSavePosition="fromFilterProducts"
              />
              </li>
        </TransitionGroup>
        <TransitionGroup v-if="!fromFilterProducts" name="products-list" tag="ul" id="productsItemsList" class="products-items-list" style="column-gap: 0.5rem !important;">
        <li v-for="product in productsList" :key="product.id"
            :data-product-id="product.id"
            @click="saveProductCardPosition(product.id)">
          <!-- we disable visiting the store here since they are already inside the store page -->
          <ProductItem
            @prepareItemToDelete="prepareItemToDelete"
            :hasDeleteItem="hasDeleteItem"
            :item="product"
            :favoriteProductsIDs="favoriteProductsIDs"
            :cardDesignId="cardDesignId"
            :withPin="withPin"
            :portalPage="portalPage"
            :encodedFilterQuery="encodedFilterQuery"
            :searchTerm="searchTerm"
            :saveProductCardPosition="saveProductCardPosition"
            :shouldSavePosition="fromFilterProducts"
          />
        </li>
      </TransitionGroup>


      <!-- Infinite Scroll instead of load more button -->
      <InfiniteScroll
        v-if="!hasReachedFullPages && !isLoading && loadMoreProducts"
        :loadMore="loadMoreProducts"
        :isLoadingMore="isLoadingMore"
        :hasReachedEnd="hasReachedFullPages"
        :isLoading="isLoading"
        :endMessage="$t('general.no_more_products')"
      >
        <!-- Content is already displayed above, this just handles the infinite scroll -->
        
        <!-- Custom end message -->
        <template #end-message>
          <div class="text-center py-6">
            <p class="text-gray-500 text-base">{{ $t('general.no_more_products') }}</p>
            <p class="text-gray-400 text-sm mt-2">{{ $t('general.you_have_seen_all_products') || 'You have seen all available products' }}</p>
          </div>
        </template>
      </InfiniteScroll>

      <!-- Remove the old load more button section -->
      <!-- <div
        class="mt-10 flex justify-center"
        v-if="!hasReachedFullPages && !isLoading"
      >
        <MoreButton
          :isLoadingMore="isLoadingMore"
          :loadMoreData="() => typeof loadMoreProducts == 'function' && loadMoreProducts()"
        />
      </div> -->
  </section>
</section>

</template>

<script>
import SectionTitle from "../SectionTitle.vue";
import ProductItem from "../productItemDesigns/ProductItem.vue";
import LoadingProductsList from "@/components/loadingSections/ProductsList.vue";
import unfavedIcon from "@/assets/images/heart-unfaved.svg";
import { mapState } from 'pinia';
import { useGlobalStore } from '@/store/Modules/global';
import MoreButton from "@/components/user/general/MoreButton.vue";
import InfiniteScroll from "@/components/common/InfiniteScroll.vue";

import StoreAdItem from "../adItems/StoreAdItem.vue";
import StoreProductAdItem from "../adItems/StoreProductAdItem.vue";

export default {
    data(){
      return{
        unfavedIcon
      }
    },
    props: {
        loadMoreProducts: {
          type: Function,
          required: false
        },
        hasDeleteItem:{
          type: Boolean,
          default: false,
        },
        isLoading: {
          type: Boolean,
          default: false,
        },
        isLoadingMore: {
          type: Boolean,
          default: false,
          required: false
        },
        isStorePage:{
          type: Boolean,
          default: false,
          required: false
        },
        productsList: {
            type: Array,
            default: () => [],
            required: true
        },
        cardDesignId: {
          type: [String, Number],
          required: false,
          default: ""
        },
        hasReachedFullPages: {
          type: Boolean,
          default: false,
          required: false
        },
        title: {
          type: String,
          required: false,
          default: ""
        },
        skeletonNumbers: {
          type: Number,
          required: false,
          default: 10
        },
        withPin: {
          type: Boolean,
          default: false,
          required: false
        },
        fromFilterProducts: {
          type: Boolean,
          default: false,
          required: false
        },
        portalPage: {
          type: String,
          default: null,
          required: false
        },
        encodedFilterQuery: {
          type: String,
          default: "",
          required: false
        },
        searchTerm: {
          type: String,
          default: "",
          required: false
        }
    },
    emits:["prepareItemToDelete"],
    methods:{
      prepareItemToDelete(item){
        this.$emit('prepareItemToDelete' , item)
      },
      saveProductCardPosition(productId) {
        this.$emit('saveProductCardPosition', productId);
      }
    },
    computed:{
      ...mapState(useGlobalStore, {
        favoriteProductsIDs: (store) => store?.getFavoriteProducts || [],
      }),
    },
    components: {
        ProductItem,
        SectionTitle,
        MoreButton,
        LoadingProductsList,
        StoreAdItem,
        StoreProductAdItem,
        InfiniteScroll
    },


}
</script>